export default {
  placeholder: {
    en: 'Type your message here',
  },
  cancel: {
    en: 'Cancel',
  },
  reply: {
    en: 'Reply',
  },
}
